module.exports = __webpack_public_path__ + "static/media/team.bde0725a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team.svg
// module id = 2055
// module chunks = 0